import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Zeytinlik Mahallesi Halı Yıkama",
    path: "/bakirkoy/zeytinlik-hali-yikama",
    description:
      "Zeytinlik Mahallesi’nde halılarınız antibakteriyel ürünlerle yıkanır, aynı gün içinde kapınıza teslim edilir."
  },
  {
    label: "Yeşilköy Halı Yıkama",
    path: "/bakirkoy/yesilkoy-hali-yikama",
    description:
      "Yeşilköy bölgesinde organik temizlik ürünleri ile çevre dostu halı yıkama hizmeti veriyoruz."
  },
  {
    label: "Ataköy Halı Yıkama",
    path: "/bakirkoy/atakoy-hali-yikama",
    description:
      "Ataköy 1-9. kısımlar dahil tüm bölgelere özel halı yıkama servisimiz ücretsiz alım ve teslimat sunar."
  },
  {
    label: "Osmaniye Mahallesi Halı Yıkama",
    path: "/bakirkoy/osmaniye-hali-yikama",
    description:
      "Osmaniye Mahallesi’nde halılarınız profesyonel makinelerde derinlemesine temizlenir, garantili teslim edilir."
  },
  {
    label: "Cevizlik Mahallesi Halı Yıkama",
    path: "/bakirkoy/cevizlik-hali-yikama",
    description:
      "Cevizlik bölgesinde halılarınızı el değmeden yıkıyor, kısa sürede adresinize ulaştırıyoruz."
  },
  {
    label: "Şenlikköy Halı Yıkama",
    path: "/bakirkoy/senlikkoy-hali-yikama",
    description:
      "Şenlikköy Mahallesi’ne özel servis araçlarımızla hızlı ve hijyenik halı yıkama hizmeti sunmaktayız."
  },
  {
    label: "Kartaltepe Halı Yıkama",
    path: "/bakirkoy/kartaltepe-hali-yikama",
    description:
      "Kartaltepe Mahallesi’nde halılarınız modern teknolojiyle yıkanır, özenle paketlenerek teslim edilir."
  },
  {
    label: "Florya Halı Yıkama",
    path: "/bakirkoy/florya-hali-yikama",
    description:
      "Bakırköy Florya semtine özel lüks ve kaliteli halı yıkama hizmetimizle, hijyen ve memnuniyet garantisi sunuyoruz."
  }
];

const BakirkoySidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">BAKIRKÖY SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BakirkoySidebar;
